<template>
  <sub-page title="失业登记">
    <div class="register-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">**杰</div>
          <div class="user-id">**************5619</div>
        </div>
      </div>

      <!-- 表单 -->
      <div class="form-body">
        <div class="form-item">
          <span class="form-label">姓名</span>
          <span class="form-value">戴义杰</span>
        </div>
        <div class="form-item">
          <span class="form-label">民族</span>
          <span class="form-value">汉族</span>
        </div>
        <div class="form-item">
          <span class="form-label">出生日期</span>
          <span class="form-value">19921028</span>
        </div>
        <div class="form-item">
          <span class="form-label">学历</span>
          <span class="form-value">大学本科</span>
        </div>
        <div class="form-item">
          <span class="form-label">毕业院校</span>
          <span class="form-value">巢湖学院</span>
        </div>
        <div class="form-item" @click="selectDate">
          <span class="form-label">毕业时间</span>
          <div class="picker">
            <span :class="['picker-value', { placeholder: !gradDate }]">{{ gradDate || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label">健康状况</span>
          <span class="form-value">健康或良好</span>
        </div>
        <div class="form-item">
          <span class="form-label">户籍性质</span>
          <span class="form-value">本省城镇</span>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="footer-btns">
        <button class="upload-btn" @click="uploadMaterial">上传材料</button>
        <button class="submit-btn" @click="handleSubmit">提交</button>
      </div>

      <!-- 毕业时间选择 -->
      <field-sheet
        :show="sheetShow"
        title="请选择毕业时间"
        :options="dateOptions"
        :value="gradDate"
        @select="onDateSelect"
        @close="sheetShow = false"
      />
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'UnemployRegister',
  components: { SubPage, FieldSheet },
  data() {
    return {
      gradDate: '',
      sheetShow: false,
      dateOptions: ['2010-06', '2011-06', '2012-06', '2013-06', '2014-06', '2015-06', '2016-06', '2017-06', '2018-06']
    }
  },
  methods: {
    selectDate() {
      this.sheetShow = true
    },
    onDateSelect(val) {
      this.gradDate = val
      this.sheetShow = false
    },
    uploadMaterial() {
      this.$alert('请上传本人身份证、学历证明、常住地证明等材料（演示环境）')
    },
    handleSubmit() {
      if (!this.gradDate) {
        this.$alert('请选择毕业时间')
        return
      }
      this.$alert('失业登记提交成功，审核通过后可享受职业介绍、职业培训等公共就业服务')
    }
  }
}
</script>

<style scoped>
.register-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
  margin-bottom: calc(16 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.form-body {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(30 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(180 * var(--w));
  flex-shrink: 0;
}
.form-value {
  flex: 1;
  font-size: calc(30 * var(--w));
  color: #323233;
}
.picker {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.picker-value {
  font-size: calc(30 * var(--w));
  color: #323233;
}
.picker-value.placeholder {
  color: #969799;
}
.picker-arrow {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.footer-btns {
  display: flex;
  gap: calc(24 * var(--w));
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.upload-btn,
.submit-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.modal {
  width: calc(600 * var(--w));
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.modal-title {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  text-align: center;
  padding: calc(40 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.modal-body {
  font-size: calc(30 * var(--w));
  color: #646566;
  text-align: center;
  padding: calc(16 * var(--w)) calc(32 * var(--w)) calc(40 * var(--w));
}
.modal-btn {
  border-top: 1px solid #f0f0f0;
  text-align: center;
  font-size: calc(34 * var(--w));
  color: #2E8CF6;
  padding: calc(28 * var(--w)) 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/UnemployRegister.vue